<template>
    <div class="content-error__wrap" v-if="!error.link">
        <h2 class="content-error">
            {{error.message}}
        </h2>
    </div>
    <a class="content-error__wrap" :href="error.link" v-else>
        <h2 class="content-error">
            {{error.message}}
        </h2>
    </a>
</template>

<script>
    export default {
        name: 'ContentError',
        props: {
            error: Object
        }
    }
</script>

<style lang="scss" scoped>

    @import "~styleguidescss/utilities/mixins";

    .content-error {
        margin: 0;
        transition: color 0.15s ease-in-out;

        font-size: $dashboard-font-size-heading;
        @include breakpoint ('max-width', $dashboard-breakpoint) {
            font-size: 18px;
        }



        &__wrap {
            width: calc(100% - 120px);
            max-width: 1080px;
            margin: 0 auto;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: center;
            border: 2px dashed rgba(0,0,0,0.15);
            border-radius: 5px;
            height: 100px;
            padding: 1vw;
            transition: border 0.15s ease-in-out;
            text-decoration: none;
            font-weight: normal;

            .content-error {
                color: rgba(0,0,0,0.15);
            }
        }
    }
    a.content-error__wrap:hover {
        border: 2px dashed rgba(0,0,0,0.45);
        .content-error {
            color: rgba(0,0,0,0.45);
        }
    }
</style>